import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import DataManagementActions from '../components/DataManagementActions';
import DataManagementPanel from '../components/DataManagementPanel';
import { closeDatasetDataManagement } from '../actions';

export default {
  ...tabTemplate('dataset-data', DataManagementPanel, matchSingleUrl(['datasets', 'data']), DataManagementActions),
  ...tabCloser('closeDatasetDataManagementTab', closeDatasetDataManagement),
  ...tabIcons('database'),
  access: ({ datasets }) => datasets.update,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  order: 235,
};
